import React, { useEffect, useState } from 'react'
import { Box, display } from '@mui/system'
import { Button, Drawer, Grid, IconButton, Paper, Stack, TextField, Typography, CircularProgress, Switch, ListItem, List, Divider, Rating, useTheme, useMediaQuery } from '@mui/material'
import { useDispatch } from 'react-redux'
import SearchIcon from '@mui/icons-material/Search';
import CandidateSideBar from './Profile/CandidateSideBar'
import Navbar from '../Navbar'
import companyLogo from '../../images/companyLogo.jpg'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import AppliedJobsTable from './AppliedJobsTable';
import Layout from '../../assets/Layout';
import UserLayout from '../../assets/UserLayout';
import ProfileCard from '../Profile/ProfileCard';
import ServiceCard from './Job/ServiceCard';
import adImage from '../../images/adImage.png'

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import jobImage from '../../images/jobImage.svg'
import jobLogoImage from '../../images/logoJobImage.svg'
import { object } from 'prop-types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BusinessIcon from '@mui/icons-material/Business';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FolderOpenOutlinedIcon from '@mui/icons-material/FolderOpenOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import AccessibilityNewOutlinedIcon from '@mui/icons-material/AccessibilityNewOutlined';
import SupervisedUserCircleOutlinedIcon from '@mui/icons-material/SupervisedUserCircleOutlined';
import facebookIcon from '../../images/facebookIcon.svg'
import twitterIcon from '../../images/twitterIcon.svg'
import linkedinIcon from '../../images/linkedinIcon.svg'
import instagramIcon from '../../images/instagramIcon.svg'
import linkIcon from '../../images/linkIcon.svg'
import documentIcon from '../../images/aplicationIcon.svg'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import JobCard from './Job/JobCard';
import profileImage from '../../images/profileImage.jpg'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { applyForJob, getAllService, getAllSimiliarJobs, getCoachServicesByID, getJobById, getUserInfoById, getUsersByProfile } from '../../actions/userAuth';
import { enqueueSnackbar } from 'notistack';

export default function AppliedJobs() {
    const [user, setUser] = useState("");
    const dispatch = useDispatch();
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);
    const [checked, setChecked] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [showEmail, setShowEmail] = useState("");
    const [jobs, setJobs] = useState("");
    const [similiarJobs, setSimiliarJobs] = useState([]);
    const [loading, setLoading] = useState(false);
    const { id } = useParams();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [coach, setCoach] = useState({});
    const [services, setServices] = useState([]);
    const [recommendedCoach, setRecommendedCoach] = useState([]);

    console.log(id)
    // useEffect(() => {
    //     window.scrollTo(0, 0);
    //     dispatch(getJobById({ id }, (data) => {
    //         setJobs(data.data);
    //     }, (err) => {
    //         console.log(err);
    //     },
    //     ))
    //     dispatch(getAllSimiliarJobs(id, (data) => {
    //         setSimiliarJobs(data.data.data);
    //     }))
    // }, [id]);

    useEffect(() => {
        dispatch(getUserInfoById({ id }, (data) => {
            setCoach(data.data);
        }, (err) => {
            console.log(err);
        },
        ))
    }, [id]);

    useEffect(() => {
        dispatch(getCoachServicesByID({ id }, (data) => {
            console.log("Services",data.data);
            setServices(data?.data?.data);
        }, (err) => {
            console.log(err);
        },
        ))
    }, [id]);

    useEffect(() => {
        dispatch(getUsersByProfile({ role: 'COACH' }, (data) => {
          setRecommendedCoach(data.data.data);
        }));
      }, []);

    console.log(coach)

    const handleSwitchOneChange = () => {
        setShowEmail(!showEmail);
    };

    const navigate = useNavigate();

    const convertDate = (inputDate) => {
        if (inputDate) {
            const dateParts = inputDate.split("-");
            const year = dateParts[0];
            const month = new Date(inputDate + "T00:00:00").toLocaleString('default', { month: 'short' });
            const day = dateParts[2];

            const outputDate = `${day} ${month} ${year}`;

            return outputDate;
        }
    }

    const ConvertMongoDate = (inputDate) => {
        const date = new Date(inputDate);

        const month = date.toLocaleString('en-US', { month: 'long' }).toUpperCase();
        const day = date.getDate().toString().padStart(2, '0');
        const year = date.getFullYear();

        const outputDate = `${month} ${day}, ${year}`;
        return outputDate;
    }

    const handleSubmit = () => {
        setLoading(true);
        let payload = {
            name: user._id,
            appliedFor: id
        }
        dispatch(applyForJob(payload, (data) => {
            enqueueSnackbar("Applied for job successfully", { variant: 'success' });
            setLoading(false);
        }, (err) => {
            enqueueSnackbar("Error Occured! Please try again", { variant: 'error' });
            setLoading(false);
        }));
    }

    const handleSearch = (event) => {
        const searchTerm = event.target.value;
    };

    return (
        <>
            <Layout>
                <UserLayout>
                    <Box sx={{ display: 'flex', flexDirection: 'row', mt: 8, borderRadius: '10px' }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>Coach Details</Typography>
                        <Box item sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center' }}>
                            <TextField
                                sx={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                className='profile-skills-box text2Light'
                                variant="outlined"
                                size="small"
                                placeholder="Search"
                                onChange={handleSearch}
                                InputProps={{
                                    endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                                }}
                            />
                        </Box>
                    </Box>
                    <Grid item md={12}>
                        <Box my={3}>
                            <Grid container spacing={2} >
                                <Grid item md={8} >
                                    <Box
                                        my={2}
                                        sx={{
                                            border: '1px solid #3665D014',
                                            borderRadius: '10px',
                                            px: 2,
                                            py: 2,
                                            backgroundColor: '#F8FAFF',
                                            position: 'relative',
                                        }}
                                    >
                                        <BookmarkBorderIcon
                                            style={{
                                                position: 'absolute',
                                                top: '24px',
                                                right: '8px',
                                                transform: 'translate(-50%, -50%)',
                                            }}
                                        />
                                        <Grid container>
                                            <Grid item md={4} >
                                                <img src={coach?.User?.avatar} alt='Image' width={'150px'} height={'150px'} style={{ objectFit: 'cover', borderRadius: '8px' }} />
                                            </Grid>
                                            <Grid item md={8}>
                                                <Stack>
                                                    <Typography className='text2Bold'>
                                                        {coach?.User?.name}
                                                    </Typography>
                                                    <Rating name="half-rating" readOnly defaultValue={2.5} precision={0.5} />
                                                    <Typography className='text2Mid' sx={{}}>
                                                        <div dangerouslySetInnerHTML={{ __html: coach?.User?.description }}></div>
                                                    </Typography>
                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                    <Stack mt={2}>
                                        <Typography mt={4} variant="h6" className='text1Bold'>
                                            About Coach Name:
                                        </Typography>
                                        <Typography sx={{ textAlign: 'justify' }} variant="body2" className='text2Mid'>
                                            <div dangerouslySetInnerHTML={{ __html: coach?.User?.description }}></div>
                                        </Typography>
                                    </Stack>

                                    <Box>
                                        <Typography mt={4} variant="h6" className='text1Bold'>
                                            Work Experience
                                        </Typography>


                                        {
                                            coach?.User?.workExperience.map((item, index) => (
                                                <Box my={2} key={index} sx={{ border: '1px solid #d2d2d2', borderRadius: '10px', px: 2, py: 2 }}>
                                                    <Grid container>
                                                        <Grid item md={3}>
                                                            <img src={adImage} alt='Image' width={'100px'} height={'100px'} style={{ objectFit: 'cover' }} />
                                                        </Grid>
                                                        <Grid item md={8}>
                                                            <Stack>
                                                                <Typography className='text2Bold'>{item.startDate} to {item.endDate}</Typography>
                                                                <Typography className='text2Bold' sx={{ color: '#2544EE' }}>
                                                                    {item.companyName}
                                                                </Typography>
                                                                <Typography className='text2Mid' sx={{ color: '#d2d2d2' }}>
                                                                    {item.designation}
                                                                </Typography>
                                                                <Typography className='text2Mid' sx={{}}>
                                                                    <div dangerouslySetInnerHTML={{ __html: item.description }}></div>
                                                                </Typography>
                                                            </Stack>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            ))
                                        }
                                    </Box>

                                    {/* <Box>
                                        <Typography mt={4} variant="h6" className='text1Bold'>
                                            Education Training
                                        </Typography>
                                        <Box my={2} sx={{ border: '1px solid #d2d2d2', borderRadius: '10px', py: 2 }}>
                                            <Grid container>
                                                <Grid item md={1} py={3} pr={1}>
                                                    <Divider sx={{ backgroundColor: '#2544EE', height: '5px', opacity: '1' }} />
                                                </Grid>
                                                <Grid item md={8}>
                                                    <Stack>
                                                        <Typography className='text2Bold'>
                                                            2020-2022
                                                        </Typography>
                                                        <Typography className='text2Bold' sx={{ color: '#2544EE' }}>
                                                            Design Communication Visual
                                                        </Typography>
                                                        <Typography className='text2Mid' sx={{ color: '#d2d2d2' }}>
                                                            Design at Massachusetts Institute of Technology & Marketing
                                                        </Typography>

                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Box> */}
                                </Grid>

                                <Grid item md={4} xs={12} >
                                    <Box sx={{ p: 1, my: 1 }}>
                                        <Typography variant="body1" className='text1Bold'>
                                            Social Media
                                        </Typography>
                                        <Grid container>
                                            <Grid item md={2}>
                                                <a href={coach?.User?.socialNetworks?.facebook}>
                                                    <img src={facebookIcon} alt='Facebook' width={'25px'} />
                                                </a>
                                            </Grid>
                                            <Grid item md={2}>
                                                <a href={coach?.User?.socialNetworks?.twitter}>
                                                    <img src={twitterIcon} alt='Twitter' width={'25px'} />
                                                </a>
                                            </Grid>
                                            <Grid item md={2}>
                                                <a href={coach?.User?.socialNetworks?.linkedIn}>
                                                    <img src={linkedinIcon} alt='LinkedIn' width={'25px'} />
                                                </a>
                                            </Grid>
                                            <Grid item md={2}>
                                                <a href={coach?.User?.socialNetworks?.instagram}>
                                                    <img src={instagramIcon} alt='Instagram' width={'25px'} />
                                                </a>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                    <Box>No Tesimonial</Box>


                                    {/* <Stack item xs={12} md={3} px={2} py={2} sx={{ background: '#EFF2FB', borderRadius: '10px' }}>
                                        <Typography
                                            variant="body"
                                            className='text1Bold'
                                        >
                                            Featured Testimonial
                                        </Typography>

                                        <Typography
                                            variant="body"
                                            className='text2Mid'
                                        >
                                            Lorem ipsum dolor sit amet consectetur. Dui egestas quisque viverra molestie praesent vitae ut.
                                            Non arcu lectus faucibus arcu volutpat tristique. Duis malesuada non dui eget nisl sagittis.
                                            Accumsan lorem massa urna vitae varius ridiculus felis mi pretium. Tellus amet pretium in euismod hendrerit fames amet sed commodo.
                                            Nunc lectus morbi sagittis amet hac feugiat id. Pharetra nisl quis aenean integer purus consectetur suscipit ante. Ipsum cursus sagittis suspendisse ut et. Lorem sollicitudin volutpat urna dolor ipsum lectus arcu libero nisl.
                                            Lectus nec volutpat etiam nunc mauris. Viverra vestibulum adipiscing habitant leo posuere. Sit dictumst ut orci urna.
                                            Adipiscing aliquam consequat amet ultrices ut elit.
                                            Ac fermentum faucibus purus eleifend.
                                        </Typography>

                                    </Stack> */}
                                    <Box
                                        my={2}
                                        sx={{
                                            position: 'relative',
                                            width: '100%',
                                            height: '25rem',
                                            borderRadius: '8px',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                backgroundColor: 'rgba(37, 68, 238, 0.5)',
                                            }}
                                        />
                                        <img src={adImage} alt='Image' width={'100%'} height={'100%'} style={{ objectFit: 'cover' }} />
                                        <Box
                                            px={2}
                                            sx={{
                                                position: 'absolute',
                                                bottom: '0px',
                                                left: '50%',
                                                transform: 'translate(-50%, -50%)',
                                                textAlign: 'left',
                                                color: '#FFF',
                                                width: '100%',
                                            }}
                                        >
                                            <Typography variant="h3" className='heading1bold' my={1}>Recruiting?</Typography>
                                            <Typography variant="body1" my={1}>Get Best Matched jobs On your Email. Add Resume Now!</Typography>
                                            <Button
                                                variant='contained'
                                                sx={{
                                                    backgroundColor: '#FFF',
                                                    color: '#2544EE',
                                                    '&:hover': {
                                                        backgroundColor: '#2544EE',
                                                        color: '#FFF',
                                                    },
                                                }}
                                            >
                                                Read More
                                            </Button>
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, my: 5 }}>
                                <Typography className='text1Bold'>Service Available</Typography>
                                <Link to="/candidate/candidate-service" className='text1Bold' sx={{ color: '#2544EE', textDecoration:'none' }} 
                                >View all</Link>
                            </Box>
                            <Grid container spacing={2}>
                                {
                                    services && services.length > 0
                                        ?
                                        services.slice(0, 4).map((service, index) => (
                                            <Grid item md={6} key={index}>
                                                <ServiceCard service={service} />
                                            </Grid>
                                        ))
                                        :
                                        ""
                                }
                            </Grid>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 2, mt: 10 }}>
                                <Typography className='text1Bold'>Recommended Coaches</Typography>
                                <Link to='/candidate/recommended-coach' className='text1Bold' sx={{ color: '#2544EE', textDecoration:'none' }} 
                                >View all</Link>
                            </Box>
                            <Grid container spacing={2} mt={4}  >
                                {
                                    recommendedCoach && recommendedCoach.length > 0
                                        ?
                                        recommendedCoach.slice(0, 4).map((item, index) => (
                                            <Grid item xs={12} md={3} key={index} mt={{ xs: 8 }}>
                                                <ProfileCard coach={item} />
                                            </Grid>
                                        ))
                                        :
                                        <Grid item xs={12} md={4} mb={5}>
                                            <Typography align="center">No Coaches found</Typography>
                                        </Grid>
                                }
                            </Grid>

                        </Box >
                    </Grid>
                </UserLayout>
            </Layout>
        </>
    )
}
